import type csrEn from "@project/lib/locales/sections/csr.en";

const csr: typeof csrEn = {
  hero: {
    eyebrow: "CSR ભાગીદારી",
    title: "સામાજિક પ્રભાવ માટે અમારી સાથે જોડાઓ",
    subtitle:
      "વડીલોને ગૌરવ, સંભાળ અને પોષણ પહોંચાડવા તથા ગૃહ ઉદ્યોગ દ્વારા મહિલાઓને સશક્ત બનાવવા જીવનધારા સાથે હાથ મિલાવો — દરેક CSR રૂપિયાને કાયમી પ્રભાવમાં ફેરવીએ.",
    becomePartner: "CSR ભાગીદાર બનો",
    download: "CSR પ્રસ્તાવ ડાઉનલોડ કરો",
    downloading: "PDF તૈયાર થઈ રહી છે…",
  },
  about: {
    eyebrow: "જીવનધારા શા માટે",
    title: "અર્થપૂર્ણ CSR માટે વિશ્વસનીય ભાગીદાર",
    description:
      "વર્ષોથી જીવનધારા એવા વડીલો માટે બીજું ઘર છે જેમને સંભાળ, સાથ અને ગૌરવની જરૂર છે. અમારા કાર્યક્રમો પારદર્શક રીતે ચાલે છે, કંપની અધિનિયમ, 2013 ની અનુસૂચિ VII હેઠળ પાત્ર છે અને દરેક યોગદાનનો હિસાબ ભાગીદારોને આપવામાં આવે છે.",
    points: {
      compliance: {
        title: "અનુસૂચિ VII અનુરૂપ",
        desc: "કંપની અધિનિયમ, 2013 ની કલમ 135 હેઠળ પાત્ર CSR પ્રવૃત્તિઓ.",
      },
      tax: {
        title: "12A અને 80G પ્રમાણિત",
        desc: "યોગદાન માટે કરમુક્તિ ધરાવતું નોંધાયેલ ટ્રસ્ટ.",
      },
      reporting: {
        title: "પારદર્શક અહેવાલ",
        desc: "દરેક પ્રોજેક્ટ માટે ઉપયોગ પ્રમાણપત્ર, ફોટા અને પ્રભાવ અહેવાલ.",
      },
      engagement: {
        title: "કર્મચારી સહભાગિતા",
        desc: "તમારી ટીમ માટે સ્વયંસેવા દિવસો અને કેમ્પસ મુલાકાત.",
      },
    },
  },
  areas: {
    eyebrow: "મુખ્ય ક્ષેત્રો",
    title: "તમારું CSR ક્યાં પ્રભાવ સર્જે છે",
    description:
      "એક ક્ષેત્ર પસંદ કરો અથવા અનેક જોડો — અમે તમારા CSR લક્ષ્યો મુજબ ભાગીદારી ઘડીએ છીએ.",
    elderlyCare: {
      title: "વડીલોની સંભાળ",
      desc: "જેમની સંભાળ લેનાર કોઈ નથી તેવા વડીલો માટે સુરક્ષિત આશ્રય, સેવકો, વસ્ત્રો અને દૈનિક સંભાળ.",
    },
    healthcare: {
      title: "આરોગ્ય સેવા",
      desc: "નિવાસીઓ માટે તબીબી તપાસ, દવાઓ, ફિઝિયોથેરાપી અને હોસ્પિટલ સહાય.",
    },
    meals: {
      title: "પૌષ્ટિક ભોજન",
      desc: "ભોજનશાળા અને ટિફિન સેવા દ્વારા જરૂરિયાતમંદ વડીલોને દિવસમાં ત્રણ પૌષ્ટિક ભોજન.",
    },
    community: {
      title: "સમુદાય કલ્યાણ",
      desc: "ગૌશાળા, તહેવારો, સેવા કેમ્પ અને સમુદાયને મજબૂત બનાવતા કાર્યક્રમો.",
    },
    women: {
      title: "મહિલા સશક્તિકરણ",
      desc: "ગૃહ ઉદ્યોગ દ્વારા મહિલાઓને રોજગાર — તાલીમ, ઉત્પાદન અને યોગ્ય આવક.",
    },
  },
  impact: {
    title: "અત્યાર સુધીનો અમારો પ્રભાવ",
    elders: "વડીલોની સંભાળ",
    wellWishers: "શુભેચ્છકો અને દાતાઓ",
    services: "સમાજ માટે સેવાઓ",
    years: "સેવાના વર્ષો",
  },
  process: {
    stepLabel: "પગલું",
    eyebrow: "પ્રક્રિયા",
    title: "અમારી સાથે ભાગીદારીના સરળ પગલાં",
    step1: {
      title: "તમારી રુચિ જણાવો",
      desc: "તમારા મુખ્ય ક્ષેત્રો અને બજેટ સાથે CSR પૂછપરછ ફોર્મ ભરો.",
    },
    step2: {
      title: "ચર્ચા અને આયોજન",
      desc: "તમારી CSR નીતિને અનુરૂપ પ્રોજેક્ટ ઘડવા અમારી ટીમ તમારો સંપર્ક કરશે.",
    },
    step3: {
      title: "કરાર અને યોગદાન",
      desc: "તમારા CSR ફાઇલિંગ માટે જરૂરી MoU અને દસ્તાવેજો અમે પૂર્ણ કરીએ છીએ.",
    },
    step4: {
      title: "પ્રભાવ જુઓ",
      desc: "નિયમિત અપડેટ, ઉપયોગ પ્રમાણપત્ર અને પ્રભાવ અહેવાલ મેળવો.",
    },
  },
  cta: {
    title: "કાયમી પ્રભાવ સર્જવા તૈયાર છો?",
    description:
      "અમારી CSR ટીમ સાથે વાત કરો અથવા તમારી CSR સમિતિ સાથે શેર કરવા પ્રસ્તાવ ડાઉનલોડ કરો.",
  },
  form: {
    badge: "CSR ભાગીદારી પૂછપરછ",
    title: "ચાલો સાથે મળીને પ્રભાવ સર્જીએ",
    subtitle:
      "થોડી વિગતો આપો, અમારી CSR ટીમ 2 કાર્યકારી દિવસમાં તમારો સંપર્ક કરશે.",
    companyName: "કંપની / સંસ્થાનું નામ",
    contactPerson: "સંપર્ક વ્યક્તિનું નામ",
    email: "સત્તાવાર ઈમેલ",
    mobile: "મોબાઇલ નંબર",
    designation: "હોદ્દો",
    interests: "ભાગીદારીના રસના ક્ષેત્રો",
    contribution: "અંદાજિત CSR યોગદાન",
    duration: "પસંદગીની ભાગીદારી અવધિ",
    message: "સંદેશ",
    messagePlaceholder: "તમારા CSR લક્ષ્યો અથવા પ્રશ્નો વિશે જણાવો…",
    selectPlaceholder: "વિકલ્પ પસંદ કરો",
    consent:
      "હું સંમત છું કે જીવનધારા આ પૂછપરછ અંગે મારો સંપર્ક કરી શકે અને તેની ગોપનીયતા નીતિ મુજબ આ વિગતોનો ઉપયોગ કરી શકે.",
    submit: "પૂછપરછ મોકલો",
    submitting: "મોકલી રહ્યા છીએ…",
    successTitle: "સંપર્ક કરવા બદલ આભાર!",
    successMessage:
      "તમારી CSR ભાગીદારી પૂછપરછ મળી ગઈ છે. અમારી ટીમ ટૂંક સમયમાં તમારો સંપર્ક કરશે.",
    close: "બંધ કરો",
    validation: {
      companyName: "કૃપા કરી કંપનીનું નામ દાખલ કરો",
      contactPerson: "કૃપા કરી સંપર્ક વ્યક્તિનું નામ દાખલ કરો",
      email: "કૃપા કરી માન્ય સત્તાવાર ઈમેલ દાખલ કરો",
      mobile: "કૃપા કરી માન્ય 10 અંકનો મોબાઇલ નંબર દાખલ કરો",
      interests: "કૃપા કરી ઓછામાં ઓછું એક ક્ષેત્ર પસંદ કરો",
      consent: "આગળ વધવા ગોપનીયતા સંમતિ સ્વીકારો",
    },
    error: "તમારી પૂછપરછ મોકલી શકાઈ નથી. કૃપા કરી ફરી પ્રયાસ કરો.",
  },
  options: {
    contribution: {
      below50k: "₹50,000 થી ઓછું",
      "50kTo1L": "₹50,000 – ₹1,00,000",
      "1LTo5L": "₹1,00,000 – ₹5,00,000",
      "5LTo10L": "₹5,00,000 – ₹10,00,000",
      above10L: "₹10,00,000 થી વધુ",
      discuss: "ચર્ચા બાદ નક્કી કરીશું",
    },
    duration: {
      oneTime: "એક વખતનું યોગદાન",
      "3To6": "3–6 મહિના",
      "6To12": "6–12 મહિના",
      longTerm: "લાંબા ગાળાની ભાગીદારી",
    },
  },
};

export default csr;
